import { useState, useRef, useEffect } from 'react';
import { useSyncState } from 'shared/hooks/useSyncState';
import { TableContent } from 'entities/table/ui/TableContent';
import { useParams } from 'react-router-dom';
import { useAppDispatch } from 'app/store';
import { setHeaderTitle } from 'features/ui/model/uiSlice';
import { useGetBannerTypeQuery } from 'widgets/content/ui/banner-type/api/BannerTypeController';
import { DrawerBannerType } from 'widgets/content/ui/banner-type/DrawerBannerType';

const fields = [
  {
    field: 'id',
    title: 'ID',
    width: '20%',
  },
  {
    field: 'title',
    title: 'Наименование',
    width: '80%',
  },
];

export const BannerTypeWidget = () => {
  const dispatch = useAppDispatch();
  const { app_type } = useParams();
  const [pagination, setPagination] = useState<{
    page: number;
    count: number;
    search: string;
  }>({
    page: 1,
    count: 10,
    search: '',
  });
  const [isShowSearch, setIsShowSearch] = useState(false);
  const searchQuery = useSyncState('');
  const searchRef = useRef('');

  const handleSetSearch = (search: string) => {
    searchQuery.set(search);
    searchRef.current = search;
  };

  // TODO: ???
  // type Filter = {
  //   name: number | '';
  //   status: number | '';
  // };

  // const [filter, setFilter] = useState<Filter>({
  //   name: '',
  //   status: '',
  // });

  const { data: bannerTypeList, isSuccess } = useGetBannerTypeQuery(null);
  const handleClearFilter = () => {
    // setFilter({
    //   name: '',
    //   status: '',
    // });
  };
  const handleClearSearch = () => {
    setIsShowSearch(false);
    searchQuery.set('');
    searchRef.current = '';
    setPagination((prev) => ({
      ...prev,
      search: '',
    }));
  };

  useEffect(() => {
    if (app_type) {
      dispatch(setHeaderTitle(app_type!.toUpperCase()));
    }
  }, [app_type]);

  return (
    <>
      {isSuccess ? (
        <TableContent
          title="Список типов баннера"
          fields={fields}
          list={{ list: bannerTypeList }}
          count={bannerTypeList.length}
          page={pagination.page - 1}
          perPage={pagination.count}
          onPageChange={(_, page) => {
            setPagination((prev) => ({
              ...prev,
              page: page + 1,
            }));
          }}
          onRowsPerPageChange={(e) => {
            setPagination(() => ({
              page: 1,
              count: parseInt(e.target.value),
              search: pagination.search,
            }));
          }}
          isShowSearch={isShowSearch}
          onShowSearch={(showSearch) => setIsShowSearch(showSearch)}
          onClearSearch={handleClearSearch}
          onClearFilter={handleClearFilter}
          search={searchQuery.get()}
          setSearch={handleSetSearch}
          onRowClick={() => {}}
        />
      ) : (
        false
      )}
      <DrawerBannerType />
    </>
  );
};
